import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { OverviewMapRepository } from '../application/OverviewMapRepository'

export function createResilientOverviewMapRepository(
  primary: OverviewMapRepository,
  fallback: OverviewMapRepository,
): OverviewMapRepository {
  return {
    async load(filters) {
      try {
        return await primary.load(filters)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'overview', operation: 'load', fallback: true })
        const result = await fallback.load(filters)
        return {
          ...result,
          meta: {
            ...result.meta,
            source: 'fixture-fallback',
            fallbackReason: 'OVERVIEW_MAP_REMOTE_UNAVAILABLE',
          },
        }
      }
    },
  }
}
